import { IconButton, TextField, TextFieldProps } from "@mui/material";
import { Dispatch, SetStateAction, useState } from "react";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export type PasswordFieldProps = TextFieldProps;

export default function PasswordField({ ...props }: PasswordFieldProps) {
    const [showPassword, setShowPassword] = useState(false);

    return <TextField
        type={showPassword ? "text" : "password"}
        {...props}
        slotProps={{
            input: {
                endAdornment: <ShowPasswordButton
                    showPassword={showPassword}
                    setShowPassword={setShowPassword}
                    disabled={props.disabled}
                />
            },
            ...props.slotProps
        }}
    />
}

interface ShowPasswordButtonProps {
    showPassword: boolean,
    setShowPassword: Dispatch<SetStateAction<boolean>>,
    disabled?: boolean
}

function ShowPasswordButton({
    showPassword,
    setShowPassword,
    disabled
}: ShowPasswordButtonProps) {
    return <IconButton edge="end" onClick={() => setShowPassword(!showPassword)} disabled={disabled}>
        {showPassword ? <VisibilityOff /> : <Visibility />}
    </IconButton>
}